import React, { useState, useEffect } from 'react';

const GalleryWithHover = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const images = [
    { src: 'img1.jpg', alt: 'Social Audit Event 1' },
    { src: 'img2.jpg', alt: 'Community Meeting 2' },
    { src: 'img3.jpg', alt: 'District Event 3' },
    { src: 'img4.jpg', alt: 'Public Gathering 4' },
    { src: 'img5.jpg', alt: 'Audit Session 5' },
    { src: 'img6.jpg', alt: 'Community Program 6' },
    { src: 'img7.jpg', alt: 'District Activity 8' },
    { src: 'img8.jpg', alt: 'Social Initiative 9' },
    { src: 'img9.jpg', alt: 'Public Event 10' },
    { src: 'img10.jpg', alt: 'Community Engagement 11' },
    { src: 'img11.jpg', alt: 'District Program 12' },
    { src: 'img12.jpg', alt: 'Social Audit 13' },
  ];

  const isMobile = windowWidth <= 480;
  const isTablet = windowWidth > 480 && windowWidth <= 768;
  // const isDesktop = windowWidth > 768;

  const getResponsiveStyles = () => {
    return {
      container: {
        margin: '0 auto',
        padding: isMobile ? '15px 10px' : isTablet ? '20px 15px' : '25px 20px',
        background: "radial-gradient(circle at left, #B3E5FC, #d2e1e7)",
        borderRadius: isMobile ? '8px' : '10px',
      },
      heading: {
        color: '#003366',
        fontWeight: '700',
        textAlign: 'center',
        fontSize: isMobile ? '24px' : isTablet ? '28px' : '32px',
        marginBottom: isMobile ? '20px' : isTablet ? '28px' : '35px',
        paddingBottom: isMobile ? '12px' : isTablet ? '15px' : '18px',
        letterSpacing: '0.6px',
        backgroundImage: 'linear-gradient(to right, transparent, #003366, transparent)',
        backgroundSize: '120px 2px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom',
        textShadow: '0 0 6px rgba(0, 51, 102, 0.2)',
      },
      gallery: {
        display: 'grid',
        gap: isMobile ? '10px' : isTablet ? '12px' : '15px',
        padding: isMobile ? '5px' : '10px',
        gridTemplateColumns: isMobile 
          ? 'repeat(auto-fit, minmax(100px, 1fr))' 
          : isTablet 
          ? 'repeat(auto-fit, minmax(140px, 1fr))' 
          : 'repeat(auto-fit, minmax(170px, 1fr))',
      },
      galleryItem: {
        position: 'relative',
        overflow: 'hidden',
        borderRadius: isMobile ? '8px' : '10px',
        boxShadow: '0 4px 12px rgba(0, 51, 102, 0.1)',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        aspectRatio: '4/3',
        background: '#f5f5f5',
      },
      image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        transition: 'transform 0.4s ease',
      },
      overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to top, rgba(0, 51, 102, 0.8), transparent)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        opacity: isMobile ? 1 : 0,
        transition: 'opacity 0.3s ease',
        padding: isMobile ? '10px' : '20px',
      },
      // viewText: {
      //   color: '#ffffff',
      //   fontSize: isMobile ? '1px' : isTablet ? '14px' : '16px',
      //   fontWeight: '600',
      //   textTransform: 'uppercase',
      //   letterSpacing: '1px',
      // },
      lightbox: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: isMobile ? '10px' : '20px',
      },
      lightboxImage: {
        maxWidth: isMobile ? '95%' : '90%',
        maxHeight: isMobile ? '80vh' : '85vh',
        objectFit: 'contain',
        borderRadius: isMobile ? '4px' : '8px',
        boxShadow: '0 8px 32px rgba(255, 255, 255, 0.1)',
      },
      closeButton: {
        position: 'absolute',
        top: isMobile ? '10px' : '20px',
        right: isMobile ? '10px' : '30px',
        background: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
        color: '#ffffff',
        fontSize: isMobile ? '32px' : '48px',
        cursor: 'pointer',
        width: isMobile ? '40px' : '50px',
        height: isMobile ? '40px' : '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        lineHeight: '1',
        fontWeight: '300',
      },
      navButton: {
        position: 'absolute',
        background: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
        color: '#ffffff',
        fontSize: isMobile ? '32px' : '48px',
        cursor: 'pointer',
        width: isMobile ? '40px' : '50px',
        height: isMobile ? '40px' : '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        top: '50%',
        transform: 'translateY(-50%)',
        fontWeight: '300',
      },
      prevButton: {
        left: isMobile ? '10px' : '30px',
      },
      nextButton: {
        right: isMobile ? '10px' : '30px',
      },
      caption: {
        position: 'absolute',
        bottom: isMobile ? '15px' : '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#ffffff',
        fontSize: isMobile ? '12px' : isTablet ? '14px' : '16px',
        fontWeight: '500',
        background: 'rgba(0, 0, 0, 0.5)',
        padding: isMobile ? '8px 15px' : '10px 25px',
        borderRadius: '20px',
        backdropFilter: 'blur(10px)',
        maxWidth: isMobile ? '90%' : 'auto',
        textAlign: 'center',
      },
    };
  };

  const styles = getResponsiveStyles();

  const openLightbox = (index) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToPrevious = () => {
    setSelectedImage((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const goToNext = () => {
    setSelectedImage((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Our Gallery</h2>
      
      <div style={styles.gallery}>
        {images.map((image, index) => (
          <div 
            style={{
              ...styles.galleryItem,
              ...(hoveredItem === index && !isMobile ? {
                transform: 'translateY(-8px)',
                boxShadow: '0 8px 20px rgba(0, 51, 102, 0.2)',
              } : {}),
            }}
            key={index}
            onClick={() => openLightbox(index)}
            onMouseEnter={() => setHoveredItem(index)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <img 
              src={image.src} 
              alt={image.alt}
              style={{
                ...styles.image,
                ...(hoveredItem === index && !isMobile ? {
                  transform: 'scale(1.1)',
                } : {}),
              }}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/300x200?text=Image+' + (index + 1);
              }}
            />
            {/* <div 
              style={{
                ...styles.overlay,
                ...(hoveredItem === index && !isMobile ? { opacity: 1 } : {}),
              }}
            >
              <span style={styles.viewText}>View Image</span>
            </div> */}
          </div>
        ))}
      </div>

      {selectedImage !== null && (
        <div style={styles.lightbox} onClick={closeLightbox}>
          <button 
            style={{
              ...styles.closeButton,
              ...(hoveredButton === 'close' && !isMobile ? {
                background: 'rgba(255, 255, 255, 0.3)',
                transform: 'scale(1.1)',
              } : {}),
            }}
            onClick={closeLightbox}
            onMouseEnter={() => setHoveredButton('close')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            ×
          </button>
          
          <button 
            style={{
              ...styles.navButton,
              ...styles.prevButton,
              ...(hoveredButton === 'prev' && !isMobile ? {
                background: 'rgba(255, 255, 255, 0.3)',
                transform: 'translateY(-50%) scale(1.1)',
              } : {}),
            }}
            onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
            onMouseEnter={() => setHoveredButton('prev')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            ‹
          </button>
          
          <img 
            src={images[selectedImage].src} 
            alt={images[selectedImage].alt}
            style={styles.lightboxImage}
            onClick={(e) => e.stopPropagation()}
          />
          
          <button 
            style={{
              ...styles.navButton,
              ...styles.nextButton,
              ...(hoveredButton === 'next' && !isMobile ? {
                background: 'rgba(255, 255, 255, 0.3)',
                transform: 'translateY(-50%) scale(1.1)',
              } : {}),
            }}
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
            onMouseEnter={() => setHoveredButton('next')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            ›
          </button>
          
          <div style={styles.caption}>
            {images[selectedImage].alt} ({selectedImage + 1} / {images.length})
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryWithHover;